import { render, staticRenderFns } from "./org-period-add-or-update.vue?vue&type=template&id=ac6bcbd0&"
import script from "./org-period-add-or-update.vue?vue&type=script&lang=js&"
export * from "./org-period-add-or-update.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports